import React from 'react';
import SmartAd from './SmartAd';

interface AdExamplesProps {
  showAds: boolean; // This boolean controls whether ads are displayed
}

const AdExamples: React.FC<AdExamplesProps> = ({ showAds }) => {
  return (
    <div className="space-y-6">
      {/* Banner Ad Example */}
      <div className="w-full">
        <h3 className="text-lg font-semibold mb-2">Banner Ad</h3>
        <SmartAd
          slot="banner"
          enabled={showAds}
          className="w-full h-24 border border-gray-300"
          fallbackContent={
            <div className="w-full h-24 bg-gray-100 flex items-center justify-center text-gray-500">
              Ad space (disabled)
            </div>
          }
        />
      </div>

      {/* Sidebar Ad Example */}
      <div className="flex gap-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-2">Content Area</h3>
          <p className="text-gray-600">
            This is your main content area. The sidebar ad will appear next to it.
          </p>
        </div>
        <div className="w-64">
          <h3 className="text-lg font-semibold mb-2">Sidebar Ad</h3>
          <SmartAd
            slot="sidebar"
            enabled={showAds}
            adFormat="rectangle"
            className="w-full h-64 border border-gray-300"
            fallbackContent={
              <div className="w-full h-64 bg-gray-100 flex items-center justify-center text-gray-500 text-center">
                Sidebar ad space<br/>(disabled)
              </div>
            }
          />
        </div>
      </div>

      {/* In-Content Ad Example */}
      <div>
        <h3 className="text-lg font-semibold mb-2">In-Content Ad</h3>
        <p className="text-gray-600 mb-4">
          This is some content before the ad...
        </p>
        <SmartAd
          slot="inContent"
          enabled={showAds}
          className="w-full h-32 border border-gray-300 my-4"
          fallbackContent={
            <div className="w-full h-32 bg-gray-100 flex items-center justify-center text-gray-500 my-4">
              In-content ad space (disabled)
            </div>
          }
        />
        <p className="text-gray-600">
          ...and this is content after the ad.
        </p>
      </div>

      {/* Footer Ad Example */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Footer Ad</h3>
        <SmartAd
          slot="footer"
          enabled={showAds}
          className="w-full h-20 border border-gray-300"
          fallbackContent={
            <div className="w-full h-20 bg-gray-100 flex items-center justify-center text-gray-500">
              Footer ad space (disabled)
            </div>
          }
        />
      </div>
    </div>
  );
};

export default AdExamples;
